<template>
  <modal name="modal-create-complaint" :width="1000">
    <div>
      <header
        class="modal-header py25 px65 h3 sans-serif weight-800 bg-cl-secondary"
      >
        {{ $t("Select the type of complaint") }}
        <i
          slot="close"
          class="modal-close material-icons cl-bg-tertiary"
          @click="close"
        >
          close
        </i>
      </header>
      <div class="modal-content bg-cl-primary pt20 pb30 px65 cl-secondary">
        <form @submit.prevent="create" novalidate>
          <div class="row mb0">
            <div class="col-xs-12 col-sm-12 mb12 rma-type">
              <div
                v-for="(type, index) in typeOptions"
                :key="index"
                class="col-md-12"
              >
                <label class="radioStyled">
                  {{ type.label ? type.label : type.value }}
                  <input
                    type="radio"
                    :value="type.value"
                    name="rma_type"
                    v-model="rmaType"
                    @change="
                      $v.rmaType.$touch();
                      rmaTypeChanged();
                    "
                  />
                  <span class="checkmark" />
                </label>
              </div>
            </div>
          </div>
          <div class="row mb10">
            <div class="col-xs-12">
              <cms-block-chunk
                class="complaint_block"
                v-show="rmaType === ''"
                :identifier="`c_COMPLAINT_TEXT`"
                default-value="<p/>"
              />
              <cms-block-chunk
                class="complaint_block"
                v-show="rmaType === 'Door To Door'"
                :identifier="`c_COMPLAINT_DOOR_2_DOOR`"
                default-value="<p/>"
              />
              <cms-block-chunk
                class="complaint_block"
                v-show="rmaType === 'Zwrot'"
                :identifier="`c_COMPLAINT_RETURN`"
                default-value="<p/>"
              />
              <cms-block-chunk
                class="complaint_block"
                v-show="rmaType === 'Klient Trzeci'"
                :identifier="`c_COMPLAINT_PRINTE`"
                default-value="<p/>"
              />
              <cms-block-chunk
                class="complaint_block"
                v-show="rmaType === getHOME_AND_OFFICE_RMA()"
                :identifier="`c_COMPLAINT_DOM_i_BIURO`"
                default-value="<p/>"
              />
            </div>
          </div>
          <div class="row mb40">
            <div class="col-xs-6">
              <Search
                class="brdr-1 brdr-cl-black"
                style="border-radius: 24px"
                :id="'products-search'"
                :placeholder="$t('Find product ...')"
                :query="query"
                :results="filteredProducts"
                :min-query-length="3"
                :isSelectedQuery="isSelectedQuery"
                ref="productsSearch"
                @input="query = $event"
                @selectItem="handleSelectItem"
              />
            </div>
            <div class="col-xs-6">
              <button-full
                type="button"
                @click.native="addItem"
                :disabled="!isValidPositionForm()"                
                >{{ $t("Add position") }}</button-full
              >
            </div>
          </div>
          <div class="row mb0">
            <base-input
              class="col-xs-3"
              type="hidden"
              name="sku"
              style="min-height: 0px"
              v-model="sku"
              @blur="$v.sku.$touch()"
              :disabled="true"
              :placeholder="$t('SKU *')"
            />
            <base-input
              class="col-xs-3"
              type="hidden"
              name="part_number"
              style="min-height: 0px"
              v-model="part_number"
              @blur="$v.part_number.$touch()"
              :disabled="true"
              :placeholder="$t('BP model')"
            />
          </div>

          <div class="row mb40 px15 pt10" v-if="items.length > 0">
            <table class="brdr-cl-bg-secondary" style="width: 100%">
              <tbody>
                <tr
                  class="brdr-cl-bg-secondary"
                  v-for="(item, index) in items"
                  :key="getItemKey(item)"
                >
                  <td class="complaint_item product--info">
                    {{ index + 1 }}. {{ $t("BP Model") }}:
                    {{ item.part_number }}
                  </td>
                  <td class="complaint_item" v-show="rmaType === 'Zwrot' || rmaType === 'service'">
                    <base-input
                      type="text"
                      name="quantity"
                      style="min-height: 44px"
                      v-model="item.quantity"
                      @blur="$v.item.quantity.$touch()"
                      :placeholder="$t('Quantity *')"
                    />
                  </td>
                  <td
                    class="complaint_item"
                    v-show="
                      rmaType === 'Door To Door' || rmaType === 'Klient Trzeci'
                    "
                  >
                    <base-input
                      type="text"
                      name="device"
                      style="min-height: 44px"
                      v-model="item.device"
                      @blur="$v.item.device.$touch()"
                      :placeholder="$t('Printer *')"
                    />
                  </td>
                  <td class="complaint_item" v-show="rmaType === 'Zwrot'">
                    <base-input
                      type="text"
                      name="invoice"
                      style="min-height: 44px"
                      v-model="item.invoice"
                      @blur="$v.item.invoice.$touch()"
                      :placeholder="$t('Invoice *')"
                    />
                  </td>
                  <td
                    class="complaint_item"
                    v-show="
                      rmaType === 'Door To Door' || rmaType === 'Klient Trzeci'
                    "
                  >
                    <base-select
                      name="reason"
                      :options="reasonOptions"
                      :placeholder="$t('Reason *')"
                      style="min-height: 44px"
                      v-model="item.reason"
                      autocomplete="off"
                      @blur="$v.item.reason.$touch()"
                      @change="$v.item.reason.$touch()"
                    />
                  </td>
                  <td style="text-align: right">
                    <button
                      type="button"
                      style="border: 2px solid #000000"
                      @click="deleteItem(item.sku, index)"
                    >
                      {{ $t("Remove") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row mb10" v-show="rmaType !== getHOME_AND_OFFICE_RMA()">
            <base-input
              class="col-xs-12"
              type="text"
              name="companyName"
              v-model="companyName"
              @blur="$v.companyName.$touch()"
              :placeholder="$t('Company name')"
            />
          </div>
          <div class="row mb10">
            <base-input
              class="col-xs-6"
              type="text"
              name="firstName"
              v-model="firstName"
              @blur="$v.firstName.$touch()"
              :placeholder="$t('First name *')"
              :validations="[
                {
                  condition: !$v.firstName.required && $v.firstName.$error,
                  text: $t('Field is required.'),
                },
              ]"
            />
            <base-input
              class="col-xs-6"
              type="text"
              name="lastName"
              v-model="lastName"
              @blur="$v.lastName.$touch()"
              :placeholder="$t('Last name *')"
              :validations="[
                {
                  condition: !$v.lastName.required && $v.lastName.$error,
                  text: $t('Field is required.'),
                },
              ]"
            />
          </div>
          <div class="row mb10">
            <base-input
              class="col-xs-6"
              type="text"
              name="street"
              v-model="street"
              @blur="$v.street.$touch()"
              :placeholder="$t('Street name *')"
              :validations="[
                {
                  condition: !$v.street.required && $v.street.$error,
                  text: $t('Field is required.'),
                },
              ]"
            />
            <base-input
              class="col-xs-3"
              type="text"
              name="house"
              v-model="house"
              @blur="$v.house.$touch()"
              :placeholder="$t('House *')"
              :validations="[
                {
                  condition: !$v.house.required && $v.house.$error,
                  text: $t('Field is required.'),
                },
              ]"
            />
            <base-input
              class="col-xs-3"
              type="text"
              name="flat"
              v-model="flat"
              @blur="$v.flat.$touch()"
              :placeholder="$t('Flat')"
            />
          </div>
          <div class="row mb10">
            <base-input
              class="col-xs-6"
              type="text"
              name="city"
              v-model="city"
              @blur="$v.city.$touch()"
              :placeholder="$t('City *')"
              :validations="[
                {
                  condition: !$v.city.required && $v.city.$error,
                  text: $t('Field is required.'),
                },
              ]"
            />
            <base-input
              class="col-xs-3"
              type="text"
              name="postcode"
              v-model="postcode"
              @blur="$v.postcode.$touch()"
              :placeholder="$t('Postcode *')"
              :validations="[
                {
                  condition: !$v.postcode.required && $v.postcode.$error,
                  text: $t('Field is required.'),
                },
              ]"
            />
            <base-input
              class="col-xs-3"
              type="text"
              name="phone"
              v-model="phone"
              @blur="$v.phone.$touch()"
              :placeholder="$t('Phone *')"
              :validations="[
                {
                  condition: !$v.phone.required && $v.phone.$error,
                  text: $t('Field is required.'),
                },
              ]"
            />
          </div>
          <div class="row mb10" v-show="rmaType === getHOME_AND_OFFICE_RMA()">
            <base-input
              class="col-xs-6"
              type="text"
              name="invoiceNumber"
              v-model="invoiceNumber"
              @blur="$v.invoiceNumber.$touch()"
              :placeholder="$t('Invoice number *')"
              :validations="[
                {
                  condition: !$v.invoiceNumber.required && $v.invoiceNumber.$error,
                  text: $t('Field is required.'),
                },
              ]"
            />
            <base-input
              class="col-xs-6"
              type="text"
              name="email"
              v-model="email"
              @blur="$v.email.$touch()"
              :placeholder="$t('Email *')"
              :validations="[
                {
                  condition: !$v.email.required && $v.email.$error,
                  text: $t('Field is required.'),
                },
              ]"
            />
          </div>  
          <div class="row mb10" v-show="rmaType !== getHOME_AND_OFFICE_RMA()">
            <base-input
              class="col-xs-12"
              type="text"
              name="description"
              v-model="description"
              :placeholder="$t('Description')"
            />
          </div>
          <div class="row mb10" v-show="rmaType === getHOME_AND_OFFICE_RMA()">            
            <base-input
              class="col-xs-12"
              type="text"
              name="description"
              v-model="description"
              :placeholder="$t('Description of the notification')"
            />
          </div>
          <div class="row mb10">
            <span class="fs-medium lh25">{{ notification }}</span>
          </div>
          <div class="row mb10">
            <div class="col-xs-6 col-sm-6"></div>
            <div class="col-xs-6 col-sm-6">
              <!-- :disabled="$v.$invalid" -->
              <button-full
                class="mb20"
                type="submit"
                :disabled="!isValidForm()"
              >
                {{ $t("Create complaint") }}
              </button-full>
            </div>
          </div>
        </form>
      </div>
    </div>
  </modal>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@vue-storefront/i18n";
import Modal from "theme/components/core/Modal";
import ButtonFull from "theme/components/theme/ButtonFull.vue";
import BaseInput from "theme/components/core/blocks/Form/BaseInput.vue";
import BaseRadiobutton from "theme/components/core/blocks/Form/BaseRadiobutton.vue";
import BaseSelect from "theme/components/core/blocks/Form/BaseSelect";
import CmsBlockChunk from "theme/components/core/blocks/Cms/BlockChunk";
import {
  required,
  email,
  minLength,
  sameAs,
  alpha,
} from "vuelidate/lib/validators";
import Search from "theme/components/core/blocks/Box/Search.vue";

import { prepareQuickSearchQuery } from "@vue-storefront/core/modules/catalog/queries/searchPanel";

const RETURN_RMA = "Zwrot"
const D2D_RMA = "Door To Door"
const HOME_AND_OFFICE_RMA = "service"
const PRINTE_RMA = "Klient Trzeci"

export default {
  name: "CreateComplaint",
  validations: {
    part_number: {
      required,
      alpha,
    },
    sku: {
      required,
      alpha,
    },
    quantity: {
      required,
      alpha,
    },
    device: {
      required,
      alpha,
    },
    invoice: {
      alpha,
    },
    reason: {
      required,
      alpha,
    },
    rmaType: {
      required,
      alpha,
    },
    firstName: {
      required,
      alpha,
    },
    lastName: {
      required,
      alpha,
    },
    city: {
      required,
      alpha,
    },
    email: {
      required,
      email,      
    },
    street: {
      required,
      alpha,
    },
    house: {
      required,
      alpha,
    },
    flat: {
      alpha,
    },
    postcode: {
      required,
      alpha,
    },
    phone: {
      required,
      alpha,
    },
    companyName: {
      alpha,
    },
    invoiceNumber: {
      required,
      alpha,
    },
    item: {
      device: {
        alpha,
      },
      reason: {
        alpha,
      },
    },
  },
  components: {
    Modal,
    BaseInput,
    ButtonFull,
    BaseSelect,
    Search,
    BaseRadiobutton,
    CmsBlockChunk,
  },
  props: {
    typeOptions: {
      type: Array,
      default: () => [
        {
          value: D2D_RMA,
          label: "Reklamacja Blackpoint Door-To-Door",
        },
        {
          value: PRINTE_RMA,
          label: "Reklamacja Printé",
        },
        {
          value: HOME_AND_OFFICE_RMA,
          label: "Produkty z katalogu Dom i biuro"
        }
      ],
    },
  },
  data() {
    const currentUser = this.$store.state.user.current
      ? this.$store.state.user.current
      : {};
    const address =
      currentUser && currentUser.addresses ? currentUser.addresses[0] : {};
    return {
      RMA_KlientD2D: "Door To Door",
      RMA_zwrot: "Zwrot",
      rmaType: "",
      sku: "",
      part_number: "",
      device: "",
      invoice: "",
      quantity: "",
      reason: "",
      description: "",
      firstName: currentUser.firstname,
      lastName: currentUser.lastname,
      email: currentUser.email,
      phone: "",
      sellDate: "",
      companyName: "",
      invoiceNumber: "",
      phone: "",
      street:
        address.street && address.street.length > 0 ? address.street[0] : "",
      house:
        address.street && address.street.length > 0 ? address.street[1] : "",
      flat: "",
      city: address.city,
      postcode: address.postcode,
      state: "",
      notification: "",
      items: [],
      query: "",
      isSelectedQuery: false,
      isSubmitting: false,
      productsList: [],
      legacyTypeOptions: [
        {
          value: D2D_RMA,
          label: "Reklamacja Blackpoint Door-To-Door",
        },
        {
          value: PRINTE_RMA,
          label: "Reklamacja Printé",
        },
        {
          value: RETURN_RMA,
          label: "Zwrot",
        },
      ],
      reasonOptions: [
        {
          value: "Nie drukuje",
          label: "Nie drukuje",
        },
        {
          value: "Nie rozpoznaje drukarka",
          label: "Nie rozpoznaje drukarka",
        },
        {
          value: "Niekompatybilny produkt z drukarką",
          label: "Niekompatybilny produkt z drukarką",
        },
        {
          value: "Uszkodzenie mechaniczne",
          label: "Uszkodzenie mechaniczne",
        },
        {
          value: "Wylany tusz",
          label: "Wylany tusz",
        },
        {
          value: "Zainstalowany stary typ pojemnika",
          label: "Zainstalowany stary typ pojemnika",
        },
        {
          value: "Zasypany",
          label: "Zasypany",
        },
        {
          value: "Źle drukuje",
          label: "Źle drukuje",
        },
        {
          value: "Inne",
          label: "Inne",
        },
      ],
    };
  },
  computed: {
    filteredProducts() {
      if (this.query.length < 3) {
        return [];
      }
      const queryByWord = this.query.split(" ");
      let products = [];
      if (this.rmaType === HOME_AND_OFFICE_RMA) {
        products = this.productsList.filter(
          (item) => item.catalog === "dom-i-biuro"
        );
      } else if (this.rmaType === D2D_RMA) {
        products = this.productsList.filter(
          (item) => item.brand_name === "Black Point" && item.catalog !== 'dom-i-biuro'
        );
      } else if (this.rmaType === PRINTE_RMA) {
        products = this.productsList.filter(
          (item) => item.brand_name !== "Black Point" && item.catalog !== 'dom-i-biuro'
        );
      } else {
        products = this.productsList.filter(
          (item) => item.catalog !== 'dom-i-biuro'
        );
      }

      const result = products.filter((product) => {
        const keysToSearch = ["name", "sku", "description", "part_number"];
        let match = false;

        for (const key of keysToSearch) {
          if (key in product) {
            const exactMatch = product[key]
              .toLowerCase()
              .includes(this.query.toLowerCase());
            const roughMatch =
              !exactMatch &&
              queryByWord.every((word) =>
                product[key].toLowerCase().includes(word.toLowerCase())
              );
            if (exactMatch || roughMatch) {
              match = true;
              break;
            }
          }
        }

        return match;
      });
      return result;
    },
    filteredProducts_v2() {
      const requiredKeys = ["name", "sku"];
      if (!this.query || this.query.length < 3) {
        return [];
      }
      let searchQuery = prepareQuickSearchQuery(this.query);
      let startValue = 0;
      let size = 1000;
      // this.start = startValue
      // this.readMore = false
      try {
        this.$store
          .dispatch("product/findProducts", {
            searchQuery,
            start: 0,
            size: size,
            options: {
              populateRequestCacheTags: false,
              prefetchGroupProducts: false,
            },
          })
          .then((result) => {
            return result.items;
          })
          .catch((err) => {
            console.error(err);
            return [];
          });
      } catch (err) {
        Logger.error(err, "components-search")();
      }
    },
  },
  beforeMount() {
    // TODO replace by search adapter - filteredProducts_v2
    this.preFilterProducts();
  },
  methods: {
    async preFilterProducts() {
      const result = await this.$store.dispatch("product/list", {
        size: 10000,
        sort: "priority:desc",
      });

      const products = result ? result.items : [];
      const requiredKeys = [
        "name",
        "sku",
        //"cena_oem",
        "price_incl_tax",
        //"kod_oem",
        "final_price",
        //"wydajnosc",
        //"wydajnosc_oem",
        "catalog"
      ];
      // TODO add 'Blac Point' to configuration
      this.productsList = products.filter((item) =>
        requiredKeys.every((key) => key in item)
      );
    },
    getItemKey(item, index) {
      return item.sku + "-" + index;
    },
    handleSelectItem(item) {
      this.sku = item.sku;
      this.part_number = item.part_number;
      this.isSelectedQuery = true;
      this.query = item.name;

      setTimeout(() => {
        this.isSelectedQuery = false;
      }, 500);
    },
    close() {
      this.$bus.$emit("modal-hide", "modal-create-complaint");
    },
    rmaTypeChanged() {
      this.items = [];
    },
    addItem() {
      switch (this.rmaType) {
        case D2D_RMA: {
          this.addComplaintItem();
          break;
        }
        case PRINTE_RMA: {
          this.addComplaintItem();
          break;
        }
        case RETURN_RMA: {
          this.addReturnItem();
          break;
        }
        case HOME_AND_OFFICE_RMA: {
          this.addReturnItem();
          break;
        }
      }
      //TODO - this.$refs.productsSearch
      document.getElementById("products-search").value = "";
    },
    addComplaintItem() {
      if (!this.sku || !this.part_number) {
        return;
      }
      const result = this.items.filter((item) => item.sku === this.sku);
      this.items.push({
        sku: this.sku,
        device: "",
        reason: "",
        part_number: this.part_number,
      });
      this.cleanItemFormData();
    },
    addReturnItem() {
      if (!this.sku || !this.part_number) {
        return;
      }
      const result = this.items.filter((item) => item.sku === this.sku);
      if (result.length === 0) {
        this.items.push({
          sku: this.sku,
          quantity: 1,
          invoice: "",
          part_number: this.part_number,
        });
        this.cleanItemFormData();
      }
    },
    deleteItem(sku, idx) {
      const result = this.items.filter(
        (item, index) => item.sku !== sku && index === idx
      );
      this.items = result;
    },
    cleanData() {
      this.items = [];
    },
    cleanItemFormData() {
      this.part_number = "";
      this.sku = "";
      this.device = "";
      this.reason = "";
      this.quantity = "";
      this.invoice = "";
    },
    isValidForm() {
      
      if (this.rmaType === HOME_AND_OFFICE_RMA) {
          const invalidItem =
            this.items &&
            this.items.length === 1 &&
            this.items.find(
            (item) => (!item.quantity)            
          );
          return (
            this.items &&
            this.items.length > 0 &&
            !invalidItem &&
            this.firstName &&
            this.lastName &&
            this.email &&
            this.invoiceNumber &&
            this.city &&
            this.postcode &&
            this.street &&
            this.house &&
            this.phone
          )
      } else { 
        const invalidItem =
          this.items &&
          this.items.length > 0 &&
          this.items.find(
            (item) =>
              (this.rmaType === D2D_RMA &&
                (!item.reason || !item.device)) ||
              (this.rmaType === PRINTE_RMA &&
                (!item.reason || !item.device)) ||
              (this.rmaType === RETURN_RMA && (!item.quantity || !item.invoice))
          );
        return (
          !this.isSubmitting &&
          this.items &&
          this.items.length > 0 &&
          !invalidItem &&
          this.firstName &&
          this.lastName &&
          this.city &&
          this.postcode &&
          this.street &&
          this.house &&
          this.phone
        );
      }
    },
    isValidPositionForm() {
      switch (this.rmaType) {
        case D2D_RMA :
        case PRINTE_RMA: 
        case RETURN_RMA: {
          return this.sku;
        } 
        case HOME_AND_OFFICE_RMA: {
          return this.sku && this.items.length === 0;
        }
      }
    },
    async create() {
      this.$bus.$emit(
        "notification-progress-start",
        i18n.t("Registering the complaint ...")
      );
      
      let data = { }
      if (this.rmaType === HOME_AND_OFFICE_RMA) {
        if (this.isSubmitting) {
          return;
        }
        data = {
          rma_type: this.rmaType,
          email: this.email,
          invoice_nr: this.invoiceNumber,
          items: this.items,
          name: `${this.firstName} ${this.lastName}`,
          street: this.street,
          house: this.house,
          flat: this.flat,
          city: this.city,
          postcode: this.postcode,
          phone: this.phone,
          description: this.description
        }

      } else { 
      
        if (!this.items || this.isSubmitting) {
          return;
        }
        
        data = {
          rma_type: this.rmaType,
          items: this.items,
          companyName: this.companyName,
          name: `${this.firstName} ${this.lastName}`,
          street: this.street,
          house: this.house,
          flat: this.flat,
          city: this.city,
          postcode: this.postcode,
          phone: this.phone,
          description: this.description,
        };
      }
      this.isSubmitting = true;
      this.$store
        .dispatch("user/createComplaint", data)
        .then(async (result) => {
          this.cleanData();
          await this.$store.dispatch("user/getComplaints", {
            refresh: true,
            useCache: false,
          });
          if (result.rma_number) {
            this.notification = `Complaint has been sent successfully. The RMA number is: ${result.rma_number}.`;
          } else {
            this.notification = this.$t(
              "Complaint has been sent successfully."
            );
          }
          this.$bus.$emit("notification-progress-stop");
          this.$bus.$emit("complaint-created", result.rma_number);
          /* this.$store.dispatch('notification/spawnNotification', {
          type: 'success',
          message: this.$t(this.notification),
          action1: { label: this.$t('OK') },
          hasNoTimeout: false
          }); */
          this.isSubmitting = false;
          this.close();
        })
        .catch((err) => {
          this.$bus.$emit("notification-progress-stop");
          this.$store.dispatch("notification/spawnNotification", {
            type: "error",
            message: this.t(err.message),
            action1: { label: this.t("OK") },
          });
          this.isSubmitting = false;
        });      
    },
    getRETURN_RMA() {
      return RETURN_RMA
    },
    getD2D_RMA() {
      return D2D_RMA;
    },
    getHOME_AND_OFFICE_RMA() {
      return HOME_AND_OFFICE_RMA
    },
    getPRINTE_RMA() {
      return PRINTE_RMA
    }
  },
};
</script>

<style scoped>
.modal {
  font-size: 12px;
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.modal-close {
  cursor: pointer;
}
.modal-content {
  @media (max-width: 450px) {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.radioStyled {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 2px;
  cursor: pointer;
  color: black;
  font-size: 16px;
  line-height: 30px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.complaint_block {
  font-size: 14px;
  color: black;
}

.complaint_item {
  font-size: 14px;
  color: black;
}
.complaint_item.product--info {
  font-size: 16px;
}
</style>
<style lang="scss">
@import "~theme/css/base/text";
@import "~theme/css/variables/colors";
@import "~theme/css/helpers/functions/color";
$bg-secondary: color(secondary, $colors-background);
$color-tertiary: color(tertiary);
$color-secondary: color(secondary);
$color-error: color(error);
$color-white: color(white);
$color-black: color(black);
.rma-type {
  .radioStyled {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 16px;
    line-height: 30px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }

    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 25px;
      width: 25px;
      border-radius: 50%;
      border: 1px solid $black;

      &:after {
        content: "";
        position: absolute;
        display: none;
        top: 3px;
        left: 3px;
        width: 19px;
        height: 19px;
        border-radius: 50%;
        background: $pink;
      }
    }

    input:checked ~ .checkmark:after {
      display: block;
    }
  }
}
</style>
